module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_02"
    }
  }), _vm._v("SETTING THE SCENE: KEY COMMANDERS OF EL ALAMEIN; THE PRINCIPAL CAST")]), _vm._v(" "), _c('h3', {
    staticClass: "chtit"
  }, [_vm._v("THE BATTLES OF EL ALAMEIN")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Battles of El Alamein featured well-known and notable commanders on all sides; however there are three whose names and influence have become the stuff of legend: Auchinleck, Montgomery and Rommel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The genesis of El Alamein was formed almost 18 months previously in the destruction of the Italian Tenth Army by General Archibald Wavell and his Western Desert Force as part of Operation Compass. The German Oberkommando der Wehrmacht (OKW – Armed Forces High Command) felt that the Italians needed support to stop the Allied advance westwards and to prevent the loss of the strategically valuable North African front. The commander chosen to lead this new force would become synonymous with the desert campaign; Johannes Erwin Eugen Rommel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Known as the ‘Desert Fox’, Rommel was a career soldier who had served with the German Army since 1910. Between the wars he served in a range of command and staff posts and published "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Infanterie greift an")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Infantry Attacks")]), _vm._v("), a study of his experiences as an infantry commander during the First World War.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Promoted to Generalmajor in August 1939 Rommel commanded the Führerbegleitbatallion (FBB – Führer Escort Brigade) during the invasion of Poland, where he was able to witness the effects of Blitzkrieg for himself. As a result of lobbying Rommel was given command of 7th Panzer Division. In early 1940 he started to prepare his new division for operations in the West. During the battles for the Low Countries and France Rommel was never far from the front line and on one occasion took up arms himself, helping to repel a French counter-attack. Rommel’s drive rubbed off on his division and it earned itself the nickname ‘Gespensterdivision’ (‘Ghost Division’) as the Oberkommando des Heeres (OKH – German Army High Command) rarely knew its precise location due to the speed of its advance. With this tactical élan it was clear Rommel was becoming a master of Blitzkrieg.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 6 February 1941 Rommel was appointed commander of the new Deutsches Afrikakorps (DAK), formed from 5th Light Division, which later became 21st Panzer Division, and 15th Panzer Division. Three days later Rommel was promoted to Generalleutnant, and on 12 February arrived in Tripoli subordinated to Italian commander-in-chief General Italo Gariboldi. His arrival was part of Unternehmen Sonnenblume or Operation Sunflower, the name given to the deployment of German forces to North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("General Sir Claude Auchinleck, known as ‘The Auk’, replaced General Sir Archibald Wavell after the failure of Operation Battleaxe, the relief of Tobruk, in June 1941. Auchinleck was a product of the British Indian Army, having been commissioned into the 62nd Punjabis in 1904. At the outbreak of the Second World War Auchinleck was appointed to command the Indian 3rd Infantry Division followed by command of IV Corps in January 1940 and a subsequent promotion to lieutenant general. He went on to command the Anglo-French ground"), _c('a', {
    attrs: {
      "id": "page_03"
    }
  }), _vm._v(" forces in the ill-fated Norwegian campaign. Upon his return to the UK Auchinleck took command of V Corps, before moving to Southern Command. By the end of 1940 Auchinleck had been promoted to full general and Commander-in-Chief India.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0002-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rommel in conference. The desert was a tactician’s dream and Rommel ensured he utilized this canvas to the fullest in his drives eastwards. (German Federal Archives)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0002-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rommel (third from right), with the 25th Panzer Regiment during the Western campaign in June 1940; second from left Colonel Karl Rothenburg: Hauptmann Schulz, Chief of 1st Battalion of the 25th Panzer Regiment. (German Federal Archives)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0003-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("General Sir Archibald Wavell, Commander-in-Chief India, and General Sir Claude Auchinleck, Commander-in-Chief Middle East, in conference on 8 September 1941. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Auchinleck’s first taste of the war in the Middle East occurred in April 1941 with the defence of RAF Habbaniya in Iraq, which was under threat by the pro-Axis regime led by Arab Nationalist Ali al-Gaylan. At the time Wavell was unable to spare troops, so acting on his own initiative Auchinleck dispatched a battalion from the King’s Own Royal Regiment by air with the Indian 10th Infantry Division following by sea. By the time a relief column from Habfor (Habbaniya Force) arrived from the British Mandate of Palestine, the short-lived Anglo-Iraqi war was over.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0003-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Major General John ‘Jock’ Campbell VC, commanding officer 7th Armoured Division, with Auchinleck. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0003-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Down but not out. Later in the war Ritchie would command XII Corps in France. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In July 1941 Auchinleck replaced Wavell as Commander-in-Chief Middle East and wasted no time taking the fight to the Axis, launching Operation Crusader in November 1941 to relieve the garrison at Tobruk. Crusader was a disaster, however, Auchinleck’s lack of experience in using armour leading to five times as many tank losses as those experienced by the Axis. Within six months the Axis were in the ascendancy, taking Tobruk and driving the Allies back into Egypt, where Auchinleck managed to stem their advance at El Alamein.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By the summer of 1942 his position as Commander-in-Chief Middle East and acting General Officer Commanding Eighth Army, having relieved its original commander General Neil Ritchie in June, was untenable. He was relieved of his command in August, and returned to India.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the roles of Commander-in-Chief Middle East and General Officer Commanding Eighth Army once again split, General Sir Harold Alexander became Commander-in-Chief Middle East and Lieutenant General William Gott took command of the Eighth Army. Sadly Gott’s appointment was"), _c('a', {
    attrs: {
      "id": "page_04"
    }
  }), _vm._v(" short-lived, as he killed when his aircraft was shot down en-route to take over his new command.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0003-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("General Sir Harold Alexander, pictured here in August 1942 as Commander-in-Chief, Middle East, surveys the battlefront from an open car. To his right is Major General John Harding, Deputy Director of Military Training Middle East Command. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Captain Bernard Montgomery DSO with a fellow officer of 104th Infantry Brigade, 35th Division. Montgomery was awarded the DSO for conspicuous gallantry on 13 October 1914 during the Battle of the Aisne in which he was wounded. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a result the man originally favoured by Chief of the Imperial General Staff, General Sir Alan Brooke, to take over from Auchinleck in command of the Eighth Army arrived. Hitting the ground running, the new appointment was a great believer in Generalissimo Alexander Suvorov’s adage ‘Train hard, fight easy’. A man who respected the enemy but was resolved to beat them: Lieutenant General Bernard Law Montgomery.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A portrait of Montgomery taken during a visit to England in 1943. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery had been originally commissioned in the Royal Warwick Regiment in 1908, though barely as he was expelled for fighting and rowdiness during his studies at the Royal Military College Sandhurst. During the First World War Montgomery was wounded twice and awarded the Distinguished Service Order. Between the wars various command and staff appointments followed, including tours in Palestine and India. As Officer Commanding 9th Infantry Brigade Montgomery arranged an amphibious combined operations exercise for the new Commander-in-Chief of Southern Command, General Sir Archibald Wavell. This experience would serve Montgomery well in the war years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 1939 Montgomery took command of 3rd (Iron) Infantry Division, deploying to Belgium as part of the British Expeditionary Force (BEF). During the Phoney War period Montgomery pushed his men hard, ensuring training and discipline was maintained. As a result his division had the best performance of any British unit during the Battle of France and the subsequent withdrawal of the BEF. Montgomery’s persistence and high standards had paid dividends. It was during Operation Dynamo, the evacuation from Dunkirk, that Montgomery assumed command of II Corps from Lieutenant General Sir Alan Brooke.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On his return to the UK Montgomery was given the command of V Corps, and busied himself with preparations for the defence of Hampshire and Dorset, where he worked under Auchinleck. The working relationship between the two was far from congenial and the effects continued long after the two parted ways. In 1941 Montgomery took command of XII Corps. Based in Kent, this was subsequently extended to cover Sussex and Surrey. He continued to push his troops hard, demanding excellence in terms of physical fitness and capacity. To engender an offensive spirit he renamed his command the South-Eastern Army, holding an impressive combined-arms exercise involving over 100,000 troops in May 1942. During this time he was promoted to lieutenant general.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Arriving in theatre on 13 August 1942, Montgomery’s drive and experience would help the Allies turn a corner and leave the Germans with their first major defeat at the hands of the Western Allies.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Watching the advance. Montgomery’s personal drive made him a favourite of the men, but the bane of his fellow officers. (HMSO)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_05"
    }
  }), _vm._v("THE SUPPORTING CAST – ORDER OF BATTLE (ORBAT) AS OF 23 OCTOBER 1942")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For brevity the ORBAT of all sides has been broken down to corps and divisional level only. Commanders listed were effective 23 October 1942.")]), _vm._v(" "), _c('h4', {
    staticClass: "sidehd1"
  }, [_vm._v("AXIS FORCES")]), _vm._v(" "), _c('p', {
    staticClass: "smallhd"
  }, [_vm._v("Panzerarmee Afrika – Generalfeldmarschall Johannes Erwin Eugen Rommel")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Deutsches Afrika Korps – Generalleutnant Wilhelm Ritter von Thoma")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("15th Panzer Division – Generalmajor Gustav von Vaerst")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("21st Panzer Division – Generalmajor Heinz von Randow")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("90th Light Division – Generalleutnant Theodor Graf von Sponeck")]), _vm._v(" "), _c('p', {
    staticClass: "smallhd"
  }, [_vm._v("Italian Army Africa – Marshal Ettore Bastico")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("16th Motorised Division Pistoia – Generale di Divisione Giuseppe Falugi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("136th Armoured Division Giovani Fascisti – Generale di Divisione Ismaele Di Nisio")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Italian X Army Corps, Army Corps – Generale di Corpo d’armata Edoardo Nebbia:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("17th Infantry Division Pavia – Generale di Divisione Nazzareno Scattaglia")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("27th Infantry Division Brescia – Generale di Divisione Brunetto Brunetti")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("185th Infantry Division ‘Folgore’ – Generale di Divisione Enrico Frattini")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ramcke Parachute Brigade – Generalmajor Hermann-Bernhard Ramcke")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Italian XX Army Corps – Generale di Corpo d’armata Giuseppe de Stephanis:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("101st Motorised Division Trieste – Generale di Divisione Francisco La Ferla")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("132nd Armoured Division Ariete – Generale di Divisione Francesco Arena")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("133rd Armoured Division Littorio – Generale di Divisione Gervasio Bitossi")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("German 164th Light Africa Division – Generalleutnant Carl-Hans Lungershausen")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Italian XXI Army Corps, Generale di Corpo d’armata Enea Navarini:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("25th Infantry Division Bologna Alessandro Gloria")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("102nd Motorised Division Trento – Generale di Divisione Giorgio Masina")]), _vm._v(" "), _c('p', {
    staticClass: "smallhd"
  }, [_vm._v("Luftflotte 2 – Generalfeldmarschall Albert Kesselring")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Fliegerführer Afrika – General der Flieger Hans Seidemann")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Sturzkampfgeschwader 3")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jagdgeschwader 27")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jagdgeschwader 53")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lehrgeschwader 1")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Desert Emergency Squadron 1")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Courier Squadron Africa")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Luftgaustab z.b.V. Africa")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Air Force News Regiment Africa")]), _vm._v(" "), _c('h4', {
    staticClass: "sidehd1"
  }, [_vm._v("ALLIED FORCES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Commander-in-Chief Middle East – General the Hon. Sir Harold Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "smallhd"
  }, [_vm._v("Eighth Army – Lieutenant General Sir Bernard Montgomery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("X Corps – Lieutenant General Herbert Lumsden:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1st Armoured Division, including Hammerforce – Major General Harold Briggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("8th Armoured Division – Major General Charles Gairdner")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("10th Armoured Division – Major General Alexander Gatehouse")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("XIII Corps – Lieutenant General Brian Horrocks:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("7th Armoured Division (inc. Free French Brigade – Brigadier Marie Pierre Koenig) – Major General Allan Harding")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("44th (Home Counties) Infantry Division – Major General Ivor Hughes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("50th (Northumbrian) Infantry Division (inc. 1st Greek Infantry Brigade – Colonel Pausanias Katsotas) – Major General John Nicols")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("XXX Corps – Lieutenant General Sir Oliver Leese:")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("9th Australian Division – Major General Leslie Morshead")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("51st Highland Infantry Division – Major General Douglas Wimberley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2nd New Zealand Division – Lieutenant General Bernard Freyberg")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1st South African Division – Major General Dan Pienaar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4th Indian Infantry Division – Major General Francis Tucker")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There were also various specialist units that fell under direct Army, Corps and Divisional command such as Royal Corps of Signals detachments.")]), _vm._v(" "), _c('p', {
    staticClass: "smallhd"
  }, [_vm._v("Western Desert Air Force – Air Vice-Marshal Arthur Coningham, RAF")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("The Western Desert Air Force (WDAF) was subordinated to General Headquarters RAF Middle East commanded by Air Chief Marshal Sir William Mitchell. The following units supported ground operations on 27 October 1942:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No. 3 South African Air Force (SAAF) Bomber Wing – Colonel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Henry Martin SAAF")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("No. 232 Bomber Wing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("No. 285 Reconnaissance Wing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("No. 211 Group – Air Vice Marshal Harry Broadhurst:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("No. 233 Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("No. 239 Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("No. 244 Wing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No. 212 Group – Group Captain Harold Fenton:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("No. 243 Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("No. 7 Wing")]), _vm._v(" "), _c('p', {
    staticClass: "smallhd"
  }, [_vm._v("US Desert Air Task Force")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("The US Desert Air Task Force fell under WDAF operational control, with the exception of 81st Bombardment Squadron, part of 12th Bombardment Group.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("57th Fighter Group USAAF")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("12th Bombardment Group USAAF")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Air Ambulance Squadron")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("835th Aviation Engineer Battalion")]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_06"
    }
  }), _vm._v("PRELUDE: THE BATTLES OF GAZALA AND MERSA MATRUH")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Defeat is one thing; disgrace is another. Nothing could exceed the sympathy and chivalry of my two friends. There were no reproaches; not an unkind word was spoken. ‘What can we do to help?’ said Roosevelt. I replied at once, ‘Give us as many Sherman tanks as you can spare and ship them to the Middle East as quickly as possible.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Winston Churchill, 21 June 1942.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Rommel established his headquarters at Hotel Tobruk on 21 June 1942, the sense of triumph must have been overwhelming. The Battle of Gazala and the fall of Tobruk were the latest defeats for a year of turmoil in the British Empire. Auchinleck, on the other hand, must have been furious, for he had lost Tobruk with its much-needed garrison of 35,000 men along with two months’ worth of supplies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a result the Eighth Army was forced to withdraw beyond ‘The Wire’, the border between Italian Libya and British Egypt, to the small town of Mersa Matruh. This withdrawal became known as the ‘Gazala Gallop’, due its speed to save as much material as possible. By 29 June Mersa Matruh had fallen into Italian hands, along with its 6,000-strong garrison and supplies that were soon put to use driving Panzerarmee Afrika eastwards once more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The race for Suez was on, with Axis and Allied forces often overtaking one another, dashing headlong for safety or victory. Rommel tried to cut off the Eighth Army’s withdrawal by ordering the Afrika Korps southwards. However, this proved harder than expected as a result of the Afrika Korps using a vast amount of captured equipment (some estimates put the figure at 85 percent of the motor pool). The ensuing confusion between friend and foe worked in the Allies’ favour, yet Rommel continued his advance eastwards.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Panzerjäger-Abteilung, part of 21st Panzer Division, on the move. (Georg Weber)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eyes west. Allied infantry in defensive positions waiting for the arrival of Panzerarmee Afrika. (UK Govt)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rommel passing Commonwealth prisoners in Tobruk with DAK Chief of Staff Fritz Bayerlein. (German Federal Archives)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_07"
    }
  }), _vm._v("ACT ONE: THE FIRST BATTLE OF EL ALAMEIN: A LINE IN THE SAND")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a man to man fight, the winner is he who has one more round within himself.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Rommel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By the end of June 1942 both sides had been fighting hard in 35°C heat and the Eighth Army was truly on the back foot. Its commander Ritchie was removed on 25 June, with Auchinleck taking over. The Eighth Army could muster just over 130 serviceable tanks with a further 950 in repair behind the lines. The situation was grim indeed, with defeat seemingly a matter of time. However, the key word was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("seemingly.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Auchinleck had withdrawn to prepared defensive positions where he was able to access fresh troops and materiel. A definitive defensive line had been drawn in the sand starting at a small railway halt 260km (162 miles) from Cairo, whose name would become synonymous with both the Eighth Army and its most famous commander Montgomery; El Alamein.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("German infantry advancing towards the Egyptian border. (Library of Congress)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Qattara Depression was a mere 65km (40 miles) south of El Alamein, its close proximity allowing Auchinleck to channel and to some extent control the movements of the advancing Panzerarmee Afrika. The British withdrawal had also shortened their supply lines, with reinforcements and replacement stores being unloaded a mere 120km (75 miles) away, while to the west"), _c('a', {
    attrs: {
      "id": "page_08"
    }
  }), _vm._v(" the newly-promoted Rommel found himself wanting an extra Panzer division rather than his field marshal’s baton.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Planning a rain of fire. The command post of 83rd and 85th Batteries, 11th Field Regiment, Royal Artillery at El Alamein, July 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("An RAF Lysander flies over a convoy during the withdrawal into Egypt, 26 June 1942. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel may have gained ground courtesy of captured stores but the further east he pushed the more stretched his supply lines became. The capture of the strategic port of Tobruk was not as helpful as it might have been, since its cargo-handling equipment had been heavily damaged and the port was unable to work to full capacity. Rommel also faced reduced air cover from the Luftwaffe and Regia Aeronautica as both struggled to find suitable areas to fly from. Meanwhile Allied interceptions of Axis shipping in the Mediterranean meant that Rommel was almost constantly operating below his monthly requirement of 70,000 tons of supplies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the capture of Tobruk Rommel had intended to give Panzerarmee Afrika respite, to refit before pushing on, but the crumbling British offensive spirit at both Gazala and Mersa Matruh had boosted his confidence. He was also aware that any pause, no matter how short, would give Auchinleck the chance to build up his reserves of men and material via Alexandria and Port Said. This prompted Rommel to continue his advance, using captured stores picked up along the way to maintain his offensive. By 29 June Rommel was ready to take the fight to the Eighth Army; he would repeat his wide sweeping manoeuvre that had been extraordinarily effective at Gazala and Mersa Matruh.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prior preparation and planning. Eighth Army equipment being removed from Mersa Matruh, 26 June 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_09"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Field Marshal Erwin Rommel drawing up plans, 1942. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Auchinleck planned to engage Panzerarmee Afrika on the defensive line where he had arranged his defences in a series of ‘Boxes’, defensive pockets which varied in size from brigade to corps. These were established at key points with infantry and artillery along with mobile assets that would engage enemy forces that managed to break through the line.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile in Alexandria and Cairo the situation was one of disarray, with civil servants destroying files and Middle East Headquarters moving to Palestine. The Mediterranean Fleet dispersed to Beirut and Haifa, and plans for the destruction of ports and cargo-handling facilities were drawn up.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A 25pdr field gun of 11th Field Regiment, Royal Artillery, in action during the First Battle of El Alamein, July 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ready for the off. A Panzer II awaits the order to move. Note the DAK symbol next to the driver’s viewport. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 1 July Rommel struck, with 90th Light Division leading the way. His plan was to bypass Lieutenant General Charles Norrie’s XXX Corps’ box network around El Alamein, cutting it off before swinging south towards Alam Nayil and taking the fight to Gott’s XIII Corps. The Italians would then attack El Alamein from the west with General Alessandro Gloria’s XXI Corps, and General Giuseppe De Stefani’s’ XX Corps following the Deutsches Afrika Korps "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(")]), _vm._v("DAK"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(")")]), _vm._v(" before swinging southwards towards Victoria Cross holder Lieutenant General Bernard Freyberg’s New Zealand 2nd Division at Bab el Qattara.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The moment Panzerarmee Afrika’s 90th Light Division left their start lines Rommel’s plan began to falter, even before first contact with the Eighth Army. A combination of poor light and a sandstorm disorientated the attacking panzergrenadiers who ended up engaging with Auchinleck’s well-prepared defenders. These encounters slowed the advance down initially, though by mid-afternoon it had resumed. Elsewhere the 15th and 21st Panzer Divisions had attracted the attentions of Air Vice Marshall Arthur Coningham’s Western Desert Air Force (WDAF) as they approached their line of departure. These attacks, combined with having to pass over difficult terrain, meant their H-hour was delayed by three hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Almost immediately they ploughed headlong into the 18th Indian Infantry Brigade which had arrived from Mosul with a mere 48 hours to prepare their positions at Deir el Shein, in"), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" front of the Ruweisat Ridge. The 18th were part of the larger South African 1st Division and were able to combine the South Africans’ artillery fire with their own against the advancing DAK troops. Their commander, General der Panzertruppe Walther Nehring, a veteran of Operation Barbarossa, was taken completely by surprise. According to intelligence the 18th Brigade should not have been there. However, Nehring was fully engaged and determined to see the action through. By that evening his panzer divisions gained the upper hand and had overwhelmed the 18th, smashing it into near oblivion. The cost was high, however; he had lost eighteen of his fifty-five tanks. To the north the 90th Light Division still struggled, attracting attention from the South African gunners. Such was the weight of fire that the advance ceased and they were caught in the open, along with Rommel, for three hours.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preparing to engage. A firepower demonstration by a Hawker Hurricane of 6 Squadron RAF with its Vickers 40mm Type S anti-tank guns against derelict German tanks. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Auchinleck’s plan was working and the support given to him by the WDAF was making a difference, and combined with the efforts of the South Africans and the 18th Indian Brigade he was able to muster fresh troops who would be able to begin repelling Panzerarmee Afrika’s advances. XXX Corps was ordered to stop Rommel’s advance, and allow XIII Corps to advance northward and slam into his right flank with armour, attacking either side of the Ruweisat Ridge. At the same time the New Zealanders would leave their positions at Bab el Qattara and Naqb au Dweis and, alongside the Indian 5th Division, prepare for a mobile role.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Major General Bernard Freyberg (centre right), arriving to conduct a review of 6th Brigade, is greeted by the commander of 24th Battalion, Lieutenant Colonel Clayden Shuttleworth (left), and Brigadier Harold Barrowclough, September 1941. Freyberg’s New Zealanders would earn a fearsome reputation for their determination during the Desert Campaign. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following day the 90th Light Division was still under artillery fire and Rommel realized it needed support to continue its advance. Nehring was ordered to detach some of his armour to support the bogged-down 90th. Ironically the strengthened DAK advance coincided with the Eighth Army’s counter-attack onto the Ruweisat Ridge resulting in fierce fighting carrying on until nightfall. The tanks of Lieutenant General Herbert Lumsden’s 1st Armoured Division were held in check by DAK anti-tank guns, and Nehring’s were held in place to the north by artillery. At this point neither side had the advantage, though the DAK’s serviceable tanks numbers were now reduced to twenty-six.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By 3 July the Germans were now starting to feel the effects of the battle; exhaustion and dwindling supplies, as well as the effects of well-coordinated Allied artillery and air support, were taking their toll. The prize of the Suez Canal was slipping further from Rommel’s grasp and he was faced with some hard choices. To buy valuable time he replaced exhausted DAK troops with fresh Italian infantry and established new defensive positions protected by minefields.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Italian Semovente 75/18. These tanks, although bravely crewed, stood little chance against improved British anti-tank guns later in the El Alamein battles. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile Auchinleck, driven by political pressure from Churchill, planned to take the fight to Panzerarmee Afrika, but like the Germans, Allied troops were starting to feel fatigued and 4 July was a day of mixed results. A slightly reinforced XIII Corps advanced towards Panzerarmee Afrika from the south, but was met almost immediately by an effective anti-tank screen. To the south exhausted troops engaged with the enemy in a series of somewhat unenthusiastic attacks, which somehow managed to remove most of the enemy forces from the ridge.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Valentine tank carrying Scottish infantry pushes on. (HMSO)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Auchinleck then shifted focus to the depression of Deir al Shein south-west of the Ruweisat Ridge. Over the next few days the results of the Deir al Shein venture were lacklustre, maybe as a result of Auchinleck’s desire to strengthen the north. Rommel surmised something was going on and planned an attack southwards. Thankfully ULTRA intercepts warned Auchinleck of Rommel’s intentions. XXX Corps’ new commander Lieutenant General William Ramsden was ordered to prepare a strike northwards towards the Italian-held features of Tel el Eisa and Tel el Makh Khad.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 9 July Rommel launched a technically perfect assault upon the now-abandoned positions at Bab el Qattara with 21st Panzer leading. He then ordered the 90th Light Division eastwards to find a weak spot in the Eighth Army’s southern flank. As the 90th moved the terrific rumble of one of the largest artillery barrages ever to take place in the desert could be heard as the Australian 9th and South African 1st Divisions struck out. The Italians were taken completely by surprise with the Sabratha and Trieste Divisions being virtually destroyed. The Australians stormed forwards and at Tel el Makh Khad they were rewarded with a valuable prize; Rommel’s radio interception unit. Rommel changed his plans and sped northwards towards the Alamein Box, picking up battle groups formed from elements of 15th Panzer Division and freshly-arrived troops from the 164th Division at Tel el Eisa. For the next four days both sides tussled for the feature, with the South Africans relinquishing their gains at Tel el Makh Khad due to a misunderstanding of orders. However, the Australians had forced a salient into Rommel’s lines and held fast despite repeated assaults.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A knocked-out Italian M13/40 tank being inspected by a passing soldier, 11 July 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rommel in his personal SdKfz 250/3 command halftrack ‘Greif’. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Auchinleck was now in a position to renew his attempt to recapture the entire Ruweisat Ridge. On the night of 14 July and with illumination and ground attack provided by the WDAF, XXX and XIII Corps assaulted the ridge. The assault cut through the defences of the Italian Brescia and Pavia Divisions. Rommel’s minefields and a counter-attack by 8th Panzer Regiment slowed the New Zealanders down, but by the afternoon of 15 July a secure foothold had been gained on the ridge by Auchinleck.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel counter-attacked the New Zealanders, who were pushed off the western edge of the ridge and lost their entire HQ, including Brigadier James Burrows of 4th New Zealand Brigade, to the advancing Germans. Rommel’s attack only halted when it reached the boundary of 1st Armoured Division. Even so, Auchinleck still held half of the ridge despite Rommel’s best efforts. The following day the tit-for-tat attacks continued with neither side making much headway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 22 July Auchinleck, who had continued to harass the flanks of Panzerarmee Afrika, attacked the ridge with Indian 5th Brigade and the New Zealanders to secure Deir El Shein. This assault ended in failure, with the 5th and 8th Panzer Regiments evicting both Allied divisions before supporting armour could reach them. When the British armour finally arrived they fell victim to German superiority, losing over 130 tanks to the Germans’ three.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 26 July the Australian and South African infantry pushed southwards once more through the Axis lines toward the Miteirya Ridge. Without the necessary armoured support, which had been delayed in minefields laid by Panzerarmee Afrika"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(",")]), _vm._v(" the assault, like the attack on Deir El Shein, came to nothing. Auchinleck had no choice but to go firm and take up and reinforce defensive positions. He ordered commanders to begin the tasks of resting, training and re-organizing, and consoled himself that the Eighth Army now held the western side of the Ruweisat Ridge.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New Zealand Division cavalrymen awaiting the order to move. By this stage all sides were feeling the stress of battle and fighting was slowly ebbing away into local engagements. (New Zealand Govt)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Air Vice Marshal Arthur Coningham and Squadron Leader C.R. ‘Killer’ Caldwell, Officer Commanding No. 112 Squadron RAF. Behind them stand 112 Squadron Kittyhawks with the famous ‘shark mouth’ painted onto the air intake. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For its part the WDAF had gained a great deal of experience and Coningham’s desire to retain full tactical control of his aircraft had proved to be vital. A First World War fighter ace, Coningham demanded excellence from his subordinates, and recognized the power he had at his disposal and how best to use it. He pushed the development of the fighter-bomber role, which would help turn the tide of the battle. Throughout the battle the air support available to Auchinleck had been second to none with huge numbers of sorties flown each day. Coningham later worked hard to establish a joint approach to the use of air power with Montgomery, developing the Forward Air Control (FAC) concept.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel, however, was now low on armour and had almost exhausted his supplies. He was also getting his first taste of defeat, with Suez was now beyond his grasp and the planned invasion of Malta, Operation Herkules, cancelled. This would allow Malta to grow as a base for Allied maritime and air assets, which would increasingly disrupt Axis shipping and air transport in the Mediterranean theatre. All the while Allied reinforcements continued to arrive at Egypt’s ports.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The First Battle of El Alamein was over, and whilst losses for the Eighth Army were high, they had learned one valuable lesson; Rommel and his Panzerarmee Afrika could be beaten.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The graves of two German airmen decorated with the insignia from their destroyed Stuka. (IWM)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("INTERLUDE – TAKING STOCK AND THE BATTLE OF ALAM HALFA")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Don’t fight a battle if you don’t gain anything by winning.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Rommel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel’s supply situation remained perilous with the ports of Benghazi 1,300km (807 miles), Tobruk 640km (397 miles) and Tripoli an astonishing 1,900km (1,180 miles) to the west. Allied to this the WDAF had almost total mastery of the air and were ravaging his supply columns whilst the Maltese-based naval and air forces were taking a heavy toll of shipping. Rommel was still receiving troop reinforcements via the Crete air bridge, but it was ammunition and fuel he needed urgently as his armoured strength was slowly growing to some 200 German and 243 Italian tanks. For his part Kesselring could now call on 298 German and 460 Italian aircraft.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A fairly new-looking Bf 109 receiving a touch of camouflage. These new arrivals would bolster Kesselring’s Fliegerführer Afrika. (German Federal Archives)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Major General Sir Eric Dorman-Smith, a master of intelligence interpretation, talking with the Chief of the Imperial General Staff, General Sir Alan Brooke, at El Alamein. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the other side of Rommel’s defences the Allies had been busy. Churchill had grown impatient of Auchinleck’s wishes to be given time to reorganize and retrain the Eighth Army before mounting an offensive in mid-September. After confiding with General Sir Alan Brooke, Churchill felt new faces and new ideas were needed. In early August Auchinleck was replaced by General Sir Harold Alexander as C-in-C Middle East with Lieutenant General Bernard Montgomery taking up the reigns of the Eighth Army after Gott was killed.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Train hard, fight easy. Crews climb aboard Sherman tanks of The Queen’s Bays (2nd Dragoon Guards), of 1st Armoured Division. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery soon became a popular figure with the troops, though he was considered arrogant and wasn’t particularly well liked by many of his peers, traits which were tolerated given his success in the field. Like Auchinleck, Montgomery pointed out to Churchill that the Eighth Army simply wasn’t ready to take the offensive. The reinforcements coming into theatre, especially those in the ‘teeth arms’, needed to be trained in the new way of fighting that Montgomery wanted. Nor did Montgomery wish to waste his precious armour, especially against the professional German and Italian gunners who were masters of the concealed anti-tank ambush. Ever the innovator, Montgomery also worked with the WDAF to strengthen the collaboration between air and ground forces. This new way of fighting was best summed up as ‘Forwards as One’, with no more splitting of divisions or effort. The Eighth Army was going to be better trained, better equipped and better led, attacking as an overwhelming force and only when Montgomery was ready.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Throughout July and August both sides paused to assess the situation and rebuild, ready to attack. Rommel knew time wasn’t on his side, especially if he was to continue east. Meanwhile reconnaissance reports were unsettling; the Eighth Army was strengthening its defences from the coast to the Ruweisat Ridge. However, the area south of the Ruweisat Ridge seemed to be neglected, so here was where Rommel would strike, using the DAK as his spearhead. Its left flank would be protected by the Italian XX Corps’ Ariete and Littorio armoured divisions, the right by German and Italian reconnaissance units. To mask his intent, there would be a series of smaller infantry raids to the north and troop movements would take place at night. Unternehmen Brandung (Operation Surf) would be Rommel’s last large-scale offensive of the campaign.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unbeknown to Rommel Montgomery had access to ULTRA intercepts, and knew that Rommel intended to take the Alam Halfa Ridge, south of Ruweisat Ridge. Montgomery immediately began to strengthen his forces around that area, drawing 131st and 133rd Brigades from the recently-arrived 44th (Infantry) Division, as well as sending the divisional artillery to Alam Halfa. He then positioned 22nd Armoured Brigade at the western edge of the ridge with further defensive points west of Alam Nayil established by Freyberg’s New Zealanders and 132nd Brigade. Finally, at the eastern end of Ruweisat Ridge, he positioned 23rd Armoured Brigade in reserve. To the south were 7th Armoured Division, 4th Light Armoured and 7th Motorized Brigades. These were to stop any enemy advance, but not allow themselves to be overwhelmed and had to be ready to attack the flanks of Rommel’s forces. In the north XXX Corps and the Australian, South African and Indian divisions were held fast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The one key obstacle facing Rommel were the vastly enlarged minefields which blocked his armour, and had to be cleared if the operation was to be a success. Rommel also had to address his supply situation by 26 August, the original D-Day of the attack, as he only had enough fuel for two days’ action. Eventually Kesselring transferred 1,500 tons of fuel, which would give Rommel four days’ worth of fighting stores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the night of 30/31 August Rommel’s troops crossed their start lines, running straight into unmarked minefields whose depth almost brought the advance to halt. As engineers and infantry tackled some 150,000 mines an intense artillery barrage fell and WDAF bombers simultaneously harassed the pinned-down troops. The two brigades of 7th Armoured Division engaged the enemy before withdrawing as planned. By dawn the German timetable of advance was slowed by defenders more than ready for the anticipated attack.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel’s plan was faltering and two of his commanders were now out of action. Von Bismarck was dead and Nehring wounded, and at this point Rommel very nearly conceded defeat. However, news that a passage through the minefields had been found and the advance was continuing helped to change his mind. Given the delay, Rommel decided to push northwards before Alam Halfa, swinging past the edge of Ruweisat Ridge, before pausing to refuel and rearm.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A SdKfz 250 halts to allow officers observation to their flank. Note the Panzer III with its additional fuel canisters. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile Montgomery’s defensive plan was working well, with the Italians and 90th Light Division bogged down. Even better Rommel’s armour was advancing towards a cul-de-sac of steel with 22nd and 23rd Armoured Brigades and the New Zealanders waiting in hull-down positions and behind concealed anti-tank guns. The 15th and 21st Panzer Divisions were engaged by the defenders, who stood firm, inflicting a great deal of damage. By dusk the remaining elements of the 15th and 21st had withdrawn to resupply safely. Overhead the WDAF were dropping flares illuminating targets of opportunity for the following medium bombers and fighter-bombers. These attacks continued throughout the night.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Defending the line. A South African sapper removing anti-personnel mines from their protective containers. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following day 15th Panzer tried to outflank the 22nd Armoured Brigade, but the 7th Armoured Division intercepted them and anti-tank fire stopped the movements of both sides. Meanwhile the Italian divisions were still trying to break through minefields but the defending New Zealanders were adding to their woes with accurate artillery fire. Rommel realized the attack was pointless and gave the order for troops to dig in and prepare for another night of air attacks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery now focused on the area around Alam Halfa, determined to use it as a buffer stop. He brought 151st Brigade, which had been defending airfields to the rear, into the line as well as the South African 2nd and Indian 5th Brigades. Meanwhile the 7th Armoured were striking Rommel’s eastern flanks and still the WDAF continued to harass the DAK, with support from USAAF B-25s, clocking up nearly 500 sorties on 1 September alone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel knew his offensive was spent and on 2 September ordered a withdrawal to the westward edge of the British"), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" minefields. This really was the last throw of the dice for Panzerarmee Afrika, and the dreams of capturing the Suez Canal went with it. As he withdrew, unaware of the ULTRA intercepts, Rommel felt air superiority had stopped his advance. To counter this he ensured his forces were dispersed whenever they travelled or laagered.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Martin Baltimores of No. 232 Wing RAF flying to attack enemy positions. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The new British 6pdr anti-tank gun would more than pay for itself in action. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A final briefing? Rommel with Generalmajor Georg von Bismarck. (German Federal Archives).")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At 2300hrs on 3 September Montgomery committed the New Zealanders to battle in order to seal gaps left in the cleared minefields. The fighting was exceptionally brutal with the Italians and Germans counter-attacking the following midday. A second attack followed but was broken up by artillery and air support. Freyberg, keen to preserve the lives of his men, disengaged with Montgomery’s permission, the gaps in the minefields still being open.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A SdKfz 10 mounted with a 20mm Flak 30 gun on the move. (German Federal Archives).")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Butcher’s Bill was high; the Eighth Army lost 1,750 men, the Italians 1,051 and the Germans 1,839. Tank losses were also high with the Eighth Army losing sixty-seven, the Italians eleven and the Germans thirty-eight. The respective air forces had not escaped loss either with the WDAF losing sixty-eight aircraft, the Italians five and the Germans thirty-six.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery could now continue his work, building up to his mid-September offensive, taunting elements of Panzerarmee Afrika who watched bogus preparations for an assault from the south that would never come from the high ground at Himeimat.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A soldier stops to inspect the grave of a Panzer III crew, knocked out in the fighting. (IWM)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("ACT TWO, SCENE ONE: THE SECOND BATTLE OF EL ALAMEIN: OPERATION LIGHTFOOT")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our mandate from the Prime Minister is to destroy the Axis forces in North Africa … It can be done, and it will be done!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Montgomery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery felt that the Battle of Alam Halfa had vindicated his tactics and that the Eighth Army were ready to take the fight to Panzerarmee Afrika. Whilst defensive positions were repaired, training and rehearsals were the order of the day with every member of the Eighth Army perfecting their carefully-choreographed role in the ballet of battle to come. Now was also not the time to rob Peter to pay Paul and Montgomery ensured divisions would fight as such, with the full service support that would normally be afforded to them. Only the Free French and Greeks would be fighting at brigade level, and even then they would, like the divisions, be fully supported.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery had recently established a mobile corps of armour or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("corps de chasse")]), _vm._v(" to be an offensive weapon, designed to take advantage of breakthroughs in the front line. Once through these would run riot, harassing enemy forces and taking advantage of the ensuing chaos to establish footholds. For this task Montgomery used X Corps, and placed it under the command of First World War veteran Lieutenant General Herbert Lumsden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grant and Sherman tanks began to arrive from the US, taking their place alongside British ones in the armoured regiments from the beginning of September. Such was the volume of deliveries that by mid-October Montgomery had over 1,000 AFVs at his disposal compared to Rommel, who was able to field just over 500.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Free French had fought well against Panzerarmee Afrika. Now they were ready to take that fight back to them. (US Government)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The gun park also grew, with over 500 2pdrs, and almost 850 6pdr guns which equipped all of the anti-tank regiments. There were also over 800 25pdr guns along with 500 medium guns. When the offensive started these guns would fire the largest artillery barrage since the First World War. On top of these figures the Montgomery had 195,000 troops supported by a huge amount of stores that were easily delivered via short road and rail journeys.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery reviewed all the senior appointments within the Eighth Army, wanting only élan, innovation and drive; for"), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" those that displayed these characteristics came promotion. For those who were considered too old, tired or unproductive came the inevitable chop. Montgomery’s approach was brutal, but he was fighting a new war which needed new ideas and new ways of seeing.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Shermans were integral to Montgomery’s new")]), _vm._v(" corps de chasse "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("doctrine and they were worth their weight in gold. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coningham had been equally busy strengthening the WDAF. Now numbering 104 squadrons of RAF, Dominion and USAAF aircraft, it could face Axis airpower with considerable confidence. The WDAF would also take the fight to enemy ground forces, day and night, providing fighter cover as well as ground attack and reconnaissance, all directed in partnership with ground forces. The Royal Navy would also play a key role in the coming battle, mimicking amphibious landings behind Rommel’s lines. Montgomery had prepared a truly awe-inspiring battlespace.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gods of Thunder: A Priest 105mm self-propelled gun of the 1st Armoured Division preparing for action. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All the while political pressure continued, urging the defeat of Panzerarmee Afrika sooner rather than later. Not only would this help hurry along the relief of Malta but also force Allied influence further west in Vichy territories. But Montgomery would not be rushed, and mid-October remained the time when operations were likely to start.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the west Axis forces were suffering from low morale; constant harassment from the WDAF and Royal Navy interceptions that kept supplies low and, in the case of fuel, severely rationed. Manpower losses weren’t being made up and"), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v(" Rommel had been sent on an enforced period of leave with General der Kavallerie Georg Stumme assuming command.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To Bolster and Harangue. Churchill drives past the troops in a suitably martial Morris-Commercial 8cwt truck. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Caretaker commander Georg Stumme in 1940. His period in command was eventful and poorly timed. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before leaving, Rommel ensured that his forces were organized to meet the attack he knew would come, most likely in early October. He established a static line of defence capable of holding out against infantry attack until the arrival of supporting armour. The line was 7km (4.34 miles) deep in places and covered by minefields, anti-tank guns, artillery fire plans and armour. The defences were littered with company-sized outposts, behind which were minefields filled with almost 500,000 anti-personnel/anti-tank mines and obstacles. Then came the heavier anti-tank guns, with further minefields placed 2,000m (1.24 miles) to the rear. Along the edge of this were battalion-sized sectors with support weapons sited to deny freedom of movement to armoured incursions. Rommel’s intent was to soak up the attack, with each band of defensive positions slowing progress.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("South African engineers training with mine-detection equipment in preparation for the Second Battle of El Alamein. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What awaited the advancing Allied armour: the deadly 88mm in the anti-tank role. Note the amount of expended shell cases and the barrel in open-sights setting of this gun dug into a forward slope. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In addition to his armour, Rommel could call upon some 100,000 troops supported by 350 anti-tank guns and almost 150 of the dual-purpose 88mm Flak guns. The line was held by mixed Italian and German units, where German experience would harden Italian fighting spirit. Behind the lines were 15th Panzer Division in the north and 21st Panzer Division in the south. In reserve were the 90th Light and the Italian Trieste Motorized Divisions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Among the new appointments was General Lieutenant Wilhelm Ritter von Thoma, who would take command of the DAK from the wounded Nehring. His command would be short lived as he would be captured by Captain Grant Singer on 4 November. Sadly Singer would be killed the following day, prompting Von Thoma to write to his widow.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery’s plan was broken into three distinct elements. Operation Bertram was a deception operation to the north carried out by Commonwealth forces. Here waste packaging and materials were camouflaged and made to appear like stores. A dummy fuel pipeline was also constructed along with visually modified soft-skinned vehicles masquerading as armour. In a counter-feint, armour was disguised as trucks and transported to their start lines without drawing too much attention from Axis observers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Operation Braganza was a preliminary feint assault by 131st Infantry Brigade against the Italian 185ª Divisione Paracadutisti Folgore. The attack took place on 29/30 September with the intent of capturing the Deir el Munassib. The Italians fought well and successfully repelled the attack.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("General von Thoma surrenders to Montgomery at Eighth Army TAC HQ on 4 November 1942. His captor, Captain Grant Singer, would be killed the following day. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Operation Lightfoot was the main effort, calling for Lieutenant General Brian Horrocks’ XIII Corps to attack southward, feigning as the main effort to keep enemy forces pinned down. Meanwhile the main attack would take place westwards on a 16km (10-mile) wide front, led by XXX Corps. Infantry would clear routes through enemy lines, pushing on to a point codenamed the Oxalic Line, and allowing armour to exploit the area behind the gaps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The infantry would advance behind a creeping barrage, widening breaches as they progressed, continuing to use artillery at a local level to overwhelm the defenders. The intention was that Rommel would release his armour to stop the infantry, only for it to be met by the armour of Montgomery’s c"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("orps de chasse.")]), _vm._v(" Meanwhile XIII Corps would attack positions around Deir al Munassib, pushing 7th Armoured Division westwards, but with a warning not to get bogged down. Its task was to keep the pressure on and ensure the German armour remained in the south.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Morris truck masquerading as a Crusader Mk III. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once these objectives had been met then both corps would begin to wear down the enemy through crumbling operations, drawing enemy armour out for engagement by the anti-tank guns and armoured divisions. If enemy armour wasn’t forthcoming then 1st and 10th Armoured Divisions, known as Hammerforce"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(",")]), _vm._v(" would seek them out and engage accordingly to prevent interference with the crumbling operations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery split Lightfoot into three distinct phases, taking place over 12 days; the break-in, the dogfight and breaking the enemy. On the evening of 23 October XXX and XIII Corps assembled at their respective start lines on the edge of the Allied minefields. At 2140hrs the artillery started their barrages, first with counter-battery fire then concentrating on the forward positions. Over the next 12 days over a million artillery rounds would be fired, proving the Allies had comfortably won the logistics battle. Overhead the WDAF went to work bombing previously identified enemy positions and jamming communications, adding to the confusion.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Sunshield’ split lorry camouflage cover on a Matilda tank in the workshops at Middle East Command Camouflage Development and Training Centre, Helwan, Egypt. (Crown Copyright)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Under new management. Captured Italian M13/40 (far left) and M11/39 (middle and right) tanks being used by the Australian 6th Division Cavalry Regiment. (Australian War Memorial)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Australian troops emerge from the smoke, practising a manoeuvre that was as dangerous to friendly forces as it was to the foe; advancing behind a creeping barrage. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For Montgomery El Alamein was an opportunity to let the armour loose. A Grant tank moving up to the front, 29 October 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A destroyed German 20mm anti-aircraft gun with a relieved-looking crew. (Unknown)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("British infantry advances through the dust and smoke of the battle. (HMSO)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the north, pushing west over the Miteirya Ridge, XXX Corps’ Dominion divisions advanced. The Australian 9th Division faced stiffening resistance though elements did reach the Oxalic Line. To their south 51st Highland Division used its brigades to leapfrog over one another toward the Oxalic Line. Whilst progress was initially good, mounting casualties and a larger"), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v(" area of defensive outposts to engage slowed the 51st’s advance. In turn this delayed the mine-clearing operations on the main defensive line. Without access to safe corridors through the mines 1st Armoured Division remained observers. South of the 51st, Freyberg’s New Zealanders were led by two infantry brigades before his armoured brigade enjoyed the freedom of movement to advance onto high ground. A sound plan that had achieved its objects by nightfall saw these gains disappear after effective enemy fire had pushed the armour back.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("British infantry advances in open formation towards German positions after the night bombardment. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A 50mm Pak being prepared by German defenders: note how well dug in the position is. Axis anti-tank gunnery was highly effective throughout the campaign. (Narodowe Archiwum Cyfrowe Poland)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Major General Daniel Pienaar, a veteran of the East African and Palestinian campaigns of the First World War, followed Freyberg’s lead. However, enemy resistance stopped any advance by armour and forced the South Africans to dig in. To the south the Indian 4th Division was employed in making a series of distraction raids near to the Ruweisat Ridge. By noon on 24 October XXX Corps had breached most of the minefields and had a foothold on the Miteirya Ridge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("X Corps’ armoured divisions, who had to clear their own paths through the minefields to engage the Panzers beyond, were not so lucky. Engineers worked hard trying to clear mines in hazardous conditions ready for the corps to advance at 0200hrs. To the north only one gap was cleared for 1st Armoured Division between the Australian and Highland divisions’ boundary. To the south 10th Armoured Division could access a cleared lane within the New Zealand area of operations. Soon traffic built up, preventing armour getting to the front line. Those that made it were subjected to effective anti-tank fire and by dawn had withdrawn to hull-down positions or well beyond the range of the artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the south XIII Corps 7th Armoured and 44th Divisions had the same difficulties trying to pass through the minefields, with only one being breached. However, the attacks, along with those of Brigadier General Marie-Pierre Koenig’s Free French, helped to confuse the Italian defenders.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite determined resistance, progress was made and Montgomery was able to keep applying the pressure on Panzerarmee Afrika, wearing away the infantry and drawing the armour out into open battle.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("German panzergrenadiers waiting to move, supported by a Panzerbeobachtungswagen (artillery observation vehicle) II. (Krakow-Warsaw Press Publisher)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("ACT TWO, SCENE TWO: DOGFIGHT: THE INFERNO CONTINUES")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("… on the 27th October, 1942 … Lieutenant-Colonel Turner never ceased to go to each part of the front as it was threatened … In one case, finding a solitary six-pounder gun in action (the others being casualties) and manned only by another officer and a Sergeant, he acted as loader and with these two destroyed 5 enemy tanks. From the Victoria Cross Citation for Lieutenant Colonel")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Victor Buller Turner")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By 24 October new issues were surfacing, the main being the flow of six divisions’ worth of traffic west through the cleared bridgeheads. Montgomery was keen to keep going and 51st Highland Division pushed on to help clear passages for 1st Armoured Division. Meanwhile the New Zealanders pushed southwards from the Miteirya Ridge supported by 10th Armoured Division and artillery. Now the Australians and South Africans began their crumbling operations whilst 7th Armoured Division was still trying to pass through the second minefield. If they were unable to do so, a night attack by 44th Division was ordered to force a gap. Overhead Coningham’s air support continued to harass the Axis lines, flying over 1,000 sorties. For the defenders on the ground the inferno continued. Montgomery’s attack had achieved complete surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Desperate to get an idea of the situation, Stumme drove to the front lines to make an assessment. Nearing the front he died of a heart attack as Australian artillery shelled his transport. Von Thoma now assumed command of Panzerarmee Afrika and began counter-attacking at a local level. The OKW were aghast and Rommel was called back from leave to take command of the rapidly deteriorating situation. He arrived later the following day.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Trying to stem the tide. Italian infantry are transported to strengthen the front. (Italian Govt)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As the day progressed movement was reduced, with defensive minefields preventing the armour from breaking out into the rear areas to create havoc. The 51st Division pushed on to forge a passage through for the 1st Armoured Division, but numbers breaking though were low and their objective, Kidney Ridge, remained out of reach. No matter how hard Montgomery pushed his commanders to breach the minefields, they made little effort to try to break out. This lack of urgency was infuriating the ever-belligerent Freyberg in particular as his infantry’s successes were for naught unless bolstered by armour. The 10th Armoured Division failed to support Freyberg for fear of meeting dug-in anti-tank guns and armour.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("25pdr guns of the 2/8th Field Regiment, Royal Australian Artillery at El Alamein. The weight of fire delivered by the Allied gunners was simply incomprehensible. (Unknown)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("The 10th Armoured Division advanced that night, supported by the guns of their own artillery as well as those of the 51st and 2nd New Zealand Division. Panzerarmee Afrika responded with counter-battery fire and air support. The ensuing chaos left the advance disorganized, and by the time commanders had reorganized themselves their covering barrage had moved on too far to be effective and the advance halted. Freyberg was furious. He needed the armour to support his infantry’s advance, but what armour remained was either stalled on the forward slopes of Miteirya Ridge or stuck in minefields.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Montgomery was informed of the lack of progress by 10th Armoured he urged its commanders on the ground to advance or they would be removed. Sadly these threats had little impact, with Freyberg reporting he was unable to start crumbling operations due to the lack of armour support. Every inch the warrior, Freyberg requested artillery support to help his division advance 4km (2.5 miles) beyond the ridge. Wisely Montgomery refused, knowing casualties would have been intolerably high without armour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For his part General von Thoma was perplexed at the lack of drive by the Allies as it allowed him to strengthen his defences ready for an infantry attack on the night of 24 October. When it came it was preceded by the now-familiar huge artillery barrage, followed by a weak-spirited armoured attack. Von Thoma felt the Miteirya Ridge was the main focus of any advance and dispatched armour to meet the advancing Allies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Elsewhere XXX Corps was progressing well, despite the poor performance of their armour. However, infantry losses were high, with no reserves available for the South Africans or New Zealanders to draw from. The unwillingness of the armour to fully engage could result in stalemate or worse still give Axis armour the upper hand. Montgomery reviewed his plan and made changes. The 1st Armoured would now shield the Australians drive towards the coast. Upon successful completion of this task the axis of advance would move westwards once more, necessitating another move by Panzerarmee Afrika’s armour. The 10th Armoured would be"), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v(" withdrawn, with elements reinforcing the 1st Armoured and the remainder of XXX Corps holding Miteirya Ridge.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A mine explodes close to a convoy as it advances through enemy minefields and wire. The minefields would create havoc behind the lines as divisions of infantry and armour tried to squeeze themselves forwards. (HMSO)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0025-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whilst obsolete against Allied tanks the Panzer II could still support and secure the rear of advancing infantry and armour. (Australian War Memorial)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A CMP Field Artillery Tractor of the 9th Australian Division pulls a 25pdr field gun near the Mediterranean coast. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The attack began on 25 October with the 1st Armoured advancing, but anti-tank defences initially held them at bay, though armour-on-armour engagements saw the 1st triumphant. To the south 50th Division failed to break through the defensive minefield, but 44th Division held the ground taken by 7th Armoured Brigade. For its part XIII Corps tied up 21st Panzer and the Italian Ariete Division in the south. The night of 25/26 October saw the 51st push towards the Oxalic Line and 9th Australian Division push on towards Point 29, a rise which allowed for excellent observation. Supported by the WDAF, the Australians achieved their objective and dug in with access to the coast road.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Italian gunnery was amongst the deadliest encountered by the Allies. Often well concealed and firing over open sights, the bravery of the Italian gunners cannot be understated. (Archivio Centrale Dello Stato)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rommel returned to a desperate situation. The capture of Point 29 did little to improve his day and he immediately ordered a counter-attack, although the lack of fuel was now hampering mobility. The Australian defence plans, combined with superb air support and blistering artillery fire, soon stopped the attacking force. Rommel was forced to bring forward his reserves and position 90th Light Division in front of Point 29. Rommel also started to cast his valuable armour into fighting off small gains, armour he could ill afford to spare: 15th Panzer Division was now reduced to a mere forty tanks. Montgomery must have been ecstatic; his plan to draw Axis armour out into"), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v(" battle as well as crumble opposition was working. Rommel, on the other hand, was slowly losing control of the situation in the face of a larger force; the numbers game was paying dividends.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Reinforcements. A British soldier with his rifle and kit, newly-arrived in Egypt, 19 August 1942. Men like him would help swing the battle in the Allies’ favour. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("British tanks advance to engage German armour. (HMSO)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now the 1st Armoured Division turned its attentions to Kidney Ridge, a feature to the west. The 51st, South African and New Zealand Divisions cleared any remaining pockets of resistance before advancing those units who had not yet reached the Oxalic Line. Montgomery then formed a new strike force by removing the New Zealanders and 9th Armoured Brigade and placing them into a reserve with 10th Armoured Division. The 7th Armoured Division received a warning order to prepare to move north to join the new reserve, and 1st Armoured Division advanced northwards to draw out and contact any remaining enemy armour, thus relieving pressure on the Australians.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("October 26th/27th saw determined fighting around Kidney Ridge centred on two key points of resistance, ‘Woodstock’ and ‘Snipe’. These night attacks were intended to drive out enemy forces so armour could advance past both features safely. Supported by the artillery of X and XXX Corps, 7th Motorized Brigade advanced to contact in the north towards ‘Woodcock’ while 2nd Rifle Brigade moved south towards ‘Snipe’. The 7th found their objective quickly, whilst the 2nd encountered stiff resistance from both the German and Italian divisions. The ensuing fighting was vicious, with both sides keen to take control of these two key points. By the afternoon of 27 October 1st Armoured Division were facing a determined armoured counter-attack with ‘Snipe’ bearing the brunt. However, the 2nd Rifle Brigade held out, defeating the counter-attack with valour and élan. By the evening both ‘Woodstock’ and ‘Snipe’ were reinforced by the arrival of the 133rd Lorried Infantry Brigade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the night of 28 October the Australians pushed northwards once more towards the coast road. While stiff opposition had stopped the Australian advance, it had weakened the German 164th and 90th Divisions charged with the defence of the area. By 29 October parts of 21st Panzer Division entered the fray from the south, and at this point Montgomery released Freyberg’s infantry from reserve to clear the way for an armoured breakout along the coast road.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the night of 30 October the Australians crossed swords with the 90th Light Division in a fresh assault, which propelled them towards the coast along the coast road and railway line. The Australians then turned eastwards to capture a point called Thompson’s Post. Whilst not wholly successful, the attack created a salient into Rommel’s lines, which made withdrawal exceptionally difficult for the Axis troops caught within it. Rommel also felt that the salient could be used by Montgomery to form the basis of a powerful breakout.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Panzerjäger I, an example of a German self-propelled 47mm anti-tank gun, moving forward. (German Federal Archives)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keen to prevent the destruction of his forces, Rommel pulled 21st Panzer Division from the battle and placed them in mobile reserve at a point close to Tel el Aqqaqir. The logistics problems continued to play their part and Rommel also learned that much-needed fuel was unlikely to arrive. Meanwhile Montgomery had once again changed his mind as to where the breakout would take place. For Rommel, who was certain it would the northern salient, the surprise would be total.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abandoned German SdKfz 223 Leichter Panzerspähwagen fitted with a folding frame antenna for use with a long-range wireless set. In the background are three German 50mm Pak 38 anti-tank guns. (Australian Armed Forces)")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("ACT TWO, SCENE THREE: SUPERCHARGE: LET SLIP THE DOGS OF WAR")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If the British armour owed any debt to the infantry of 8th Army, the debt was paid on 2 November by 9th Armoured Brigade in heroism and blood …")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Montgomery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Operation Supercharge was to be the coup de grâce for Panzerarmee Afrika and XXX Corps was centre stage, making an night assault with infantry followed by armour, whilst to the south Horrocks’ XIII Corps would provide a feint attack. The main effort of Supercharge would take place 4km (2.5 miles) south of Point 29 supported by artillery and the WDAF. Freyberg’s New Zealanders, supplemented by elements from 50th and 51st Divisions, would lead the attack. This time the assault would not have to contend with deep minefields, and once the infantry had reached their objectives the armour would take over the battle. 1st Armoured Division would engage the Panzer divisions supported by their anti-tank guns, while other divisions would continue to crumble away Axis defences, either side of the main advance, continuously seeking gaps to exploit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At 0105hrs on 2 November Operation Supercharge began, with artillery pounding positions that had been subjected to nearly seven hours of attacks by the WDAF. The Royal Navy supported by simulating landings, adding tracer fire and flares to the cacophony of battle. The ground assault pushed against a 4km (2.5-mile) wide front to reach their objectives. Almost immediately the armour got to work, and two squadrons of 1st Royal Dragoons pushed past the advancing infantry, going on to have a fine time creating havoc behind enemy lines.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A 25pdr gun firing during the British night artillery barrage. Over the 12 days of the battle the field guns would fire on average 102 rounds a day. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By daybreak 9th Armoured Brigade of 10th Armoured Division had split into three and led the advance towards the Rahman Track in a bid to crack the defensive positions there.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fire for effect. The night barrages were as beautiful as they were deadly. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tanks of 8th Armoured Brigade waiting just behind the forward positions near El Alamein before being called to join the battle. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A knocked-out Churchill Mk III among abandoned Italian M13/40 tanks at El Alamein, 2 November 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0030-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A ‘Vampire’ sign outside an Army Blood Transfusion Service advanced blood bank in the Western Desert. These allowed dressing stations and mobile operating theatres to draw blood as required. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery left the commander of the 9th, Brigadier John Currie, in no doubt as to the importance of his task, saying he was prepared to take 100 percent losses in achieving this aim. Currie and ninety-four tanks advanced shortly before dawn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Advancing from the east they were silhouetted by the rising sun, making ideal targets for the anti-tank screen that waited for them. This screen consisted of German 50mm Pak 38s and Italian 47mm guns, as well as the terrifying 88mm in the ground-defence role. The ensuing engagement became the stuff of legend in cavalry circles, with the 9th Armoured Brigade reduced to just twenty-four serviceable vehicles, but achieving their goal and breaking the line.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the Rahman Track now secure the 1st Armoured Division returned to the fray, but its brigades encountered strong resistance, with the DAK showing their quality on more than one occasion. The advance was halted, but only after heavy losses on both sides. The continued Allied pressure was paying off and enemy strength was weakening by the minute. The Australians seized the opportunity and broke out of the Point 29 salient, pushing north and east.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 3 November Rommel tried to withdraw the Italian XX and XXI Corps, but an edict from Hitler forbade any withdrawal"), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v(" and Rommel was ordered to stand fast. So Panzerarmee Afrika continued to fight, holding the advancing Allies for a further two days. Montgomery knew his plan was having an effect, but had no idea how effective it was; Panzerarmee Afrika was close to collapse.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0030-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Churchill crew check their bearings whilst one of them removes tangled signals wire. This was one of six Churchills used in El Alamein as part of Kingforce, commanded by Major Norris King MC. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The prisoner cache kept growing as the battle entered its final phase. (IWM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By 4 November the retreat had started with the 15th and 21st Panzer Divisions falling back to a defensive line at Fuka. By dawn their transport was in full flight and infantry units that were able to break contact joined in the retreat. At this point the retreating Germans put their own troops’ safety ahead of that of their Italian allies, leaving many of them to be caught by the advancing Allies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Montgomery now released the 1st Armoured Division to fulfil its mobile role and once it freed itself from the traffic jams on the Rahman Track on the night of 4/5 November it set off in pursuit of the fleeing Axis forces. It was followed by 7th Armoured Division with the New Zealand 2nd Division who set off at dawn, and 10th Armoured Division also joined the chase. To the south XIII Corps advanced against fading resistance.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To the victor the spoils. Montgomery standing in front of his personal tank, 5 November 1942. (IWM)")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "subtit",
    attrs: {
      "id": "h3_9"
    }
  }, [_vm._v("ENDINGS")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now this is not the end, it is not even the beginning of the end. But it is, perhaps, the end of the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Winston Churchill on the victory at")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("El Alamein")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even now Montgomery’s reticence in delivering the death blow to the fleeing Panzerarmee Afrika is subject to much deliberation; an act of carelessness or of honour and decency? Either way, by the end of November Tobruk and Benghazi would be back in Allied hands and an Anglo-American amphibious invasion, Operation Torch, took place in Algeria and Morocco just three days later, on 8 November. Rommel was now stuck fast and within six months the war in desert would be over.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lance Corporal Charles Jeffrey, Private George McCulloch and Sergeant John Spowart of the Camerons, who all won medals for bravery at El Alamein, photographed on 26 December 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eighth Army re-enters Mersa Matruh, November 1942. (IWM)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-004dba9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter2.vue
// module id = 72
// module chunks = 0